const globalStyle = {
  a: {
    color: "black",
    textDecoration: "none",
    "&:hover, &:focus, &:active": {
      textDecoration: "none",
      color: "black",
    },
  },
  ul: { listStyle: "none", padding: "0", margin: "0" },
  input: { outline: "none" },
  button: {
    backgroundColor: "transparent",
    fontSize: "14px",
    fontWeight: 400,
    border: "none",
    outline: "none",
    borderRadius: "5px",
    textAlign: "center",
    cursor: "pointer",
    color: "black",
    "&:focus": { outline: "none" },
  },
  "p, h1, h2, h3, h4, h5, h6": { margin: "0", letterSpacing: "-0.011em" },

  // sticky footer at the bottom of page 👇
  "html, body": {
    height: "100%",
    "> #__next": { height: "100%" },
  },
  "body[dir='rtl'] .yarl__portal": {
    direction: "rtl",
    ".yarl__toolbar": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      width: "100%",
    },
    ".yarl__thumbnails_thumbnail": {
      filter: "brightness(0.5)",
    },
    ".yarl__thumbnails_thumbnail_active": {
      filter: "brightness(1)",
    },
  },
  footer: { marginTop: "auto" },
  ////////////////////////////////////////
};

export default globalStyle;
